import React from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { capitalizeFirstLetter } from "../utils/commons";

export type UserCellUser = {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
};

const getUserFullName = (user: UserCellUser) =>
  `${capitalizeFirstLetter(user.firstName || "")} ${capitalizeFirstLetter(
    user.lastName || ""
  )}`.trim() || "N/A";

const UserCell = ({
  user,
  onOpenMember,
}: {
  user: UserCellUser | null;
  onOpenMember?: (userId: string) => void;
}): JSX.Element => {
  if (!user) return <>N/A</>;

  return (
    <Box>
      <Typography
        variant="body2"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {getUserFullName(user)}
        {onOpenMember && user.id ? (
          <Tooltip title="Open member">
            <IconButton size="small" onClick={() => onOpenMember(user.id)}>
              <PersonSearchIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        ) : null}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        {user.phone ? `+91-${user.phone}` : ""}
      </Typography>
    </Box>
  );
};

export default UserCell;
